import { render, staticRenderFns } from "./SeleccionarCodigosForm.vue?vue&type=template&id=3b5d1d7c&"
import script from "./SeleccionarCodigosForm.vue?vue&type=script&lang=ts&"
export * from "./SeleccionarCodigosForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b5d1d7c', component.options)
    } else {
      api.reload('3b5d1d7c', component.options)
    }
    module.hot.accept("./SeleccionarCodigosForm.vue?vue&type=template&id=3b5d1d7c&", function () {
      api.rerender('3b5d1d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/SeleccionarCodigosForm.vue"
export default component.exports